import { atom } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { isLoggedInAtom } from '@root/entities/auth'
import { fetchReferralLeaderboardRequestAction } from '@root/entities/leaderboard'
import { dataTableNoAccessError, reatomDataTable } from '@root/shared/ui-kit'

import { leaderboardTableColumns } from '../ui/desktop/common/leaderboard-columns'

import type { LeaderboardTableEntry } from '../model'

export const reatomReferralLeaderboardTable = () => {
  const paramsAtom = atom((ctx) => {
    const isLoggedIn = ctx.spy(isLoggedInAtom)
    return {
      isLoggedIn: isLoggedIn,
    }
  }, 'paramsAtom')

  const tableModel = reatomDataTable({
    columns: leaderboardTableColumns,
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'reatomReferralsTable',
    paramsAtom: paramsAtom,
    loadItems: async (
      ctx,
      { pagination: { limit, offset }, params: { isLoggedIn } },
    ) => {
      if (!isLoggedIn) {
        return Result.fail(dataTableNoAccessError())
      }

      const entries = await fetchReferralLeaderboardRequestAction(ctx, {
        limit,
        offset,
      })

      return pipe(
        entries,
        Result.map((data) => ({
          data: data.map(
            (item): LeaderboardTableEntry => ({
              date: item.registrationDate,
              name: item.username ?? '-',
              amount: item.totalReferralBalanceUsd,
              rank: item.position,
              userId: item.id,
              currencyTicker: '$',
            }),
          ),
        })),
      )
    },
    limit: 30,
    getId: ({ userId }) => userId,
  })

  return tableModel
}
